(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabs-collection"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-testid="tabs-collection"]').forEach(function (section) {
    var tabs = Array.from(section.querySelectorAll('.tabs-collection__tab'));
    var panels = Array.from(section.querySelectorAll('.tabs-collection__panel'));

    if (tabs.length === 0) return;

    function activateTab(activeTab) {
      var panelId = activeTab.getAttribute('aria-controls');

      tabs.forEach(function (t) {
        var isActive = t === activeTab;
        t.classList.toggle('tabs-collection__tab--active', isActive);
        t.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      panels.forEach(function (panel) {
        var isActive = panel.id === panelId;
        panel.classList.toggle('tabs-collection__panel--active', isActive);
        if (isActive) {
          panel.removeAttribute('hidden');
          // Safari fix : après que le panel est visible, forcer le slideshow
          // à se repositionner sur la première slide via son API native.
          // Le double rAF garantit que WebKit a terminé son layout avant qu'on lise/écrive.
          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              panel.querySelectorAll('slideshow-container').forEach(function (sw) {
                if (typeof sw.select === 'function') {
                  sw.select(0, undefined, { animate: false });
                }
              });
            });
          });
        } else {
          panel.setAttribute('hidden', '');
        }
      });
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        activateTab(tab);
      });
    });

    // Activer le premier tab (le panel 1 est déjà visible en HTML, on synchronise juste les classes)
    if (tabs[0]) {
      tabs[0].classList.add('tabs-collection__tab--active');
      tabs[0].setAttribute('aria-selected', 'true');
    }
  });

  } catch(e) { console.error(e); }
})();
})();
